import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  communitySignupUrl,
  shouldShowSignupLink,
} from "@circle-react/helpers/communityHelpers";
import { authPathsWithRedirect } from "@circle-react/helpers/urlHelpers";
import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";

import { useEmbedAwareOpenUrl } from "./useEmbedAwareOpenUrl";

export const AuthGate = () => {
  const { currentCommunity, currentUser } = usePunditUserContext();
  const { isCommentsClosed } = useCommentsConfig();
  const openUrl = useEmbedAwareOpenUrl();

  if (!currentCommunity || currentUser || isCommentsClosed) return null;

  const loginUrl = authPathsWithRedirect.signIn();
  const {
    private_sign_up_url: privateSignupUrl,
    private_sign_up_label: privateSignupLabel,
  } = currentCommunity;
  const hasSignupLink =
    shouldShowSignupLink(currentCommunity) || !!privateSignupUrl;
  const signupUrl =
    privateSignupUrl ?? communitySignupUrl(currentCommunity) ?? loginUrl;
  const signupLabel = privateSignupUrl
    ? privateSignupLabel || t("sign_up")
    : t("sign_up");

  return (
    <div className="flex flex-col gap-6 border-primary border-y px-7 py-10 text-center">
      <Typography variant="heading-md" color="primary">
        {t("login_to_comment")}
      </Typography>
      <div className="flex items-center justify-center gap-4">
        <Button variant="outline" onClick={() => openUrl(loginUrl)}>
          {t("log_in")}
        </Button>
        {hasSignupLink && (
          <Button variant="branded" onClick={() => openUrl(signupUrl)}>
            {signupLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
